"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getPasswordValidationDetails;

var _getValidCombination = _interopRequireDefault(require("./getValidCombination"));

var _passwordRegex = require("./passwordRegex");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var DEFAULT_CONFIG = {
  minLength: 8,
  minCombination: 2
}; // In createValidator, the 2nd parameter is previousValue . And since config is required, it is better to put it as the 3rd param.

function getPasswordValidationDetails(value, previousValue) {
  var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DEFAULT_CONFIG;
  var minLength = config.minLength,
      minCombination = config.minCombination;

  if (typeof value !== 'string') {
    return null;
  } // Count array values. Returns an object.
  // Example return value: { true: 3, false: 1 };


  var validCombination = (0, _getValidCombination["default"])(value);
  return {
    // Same as password validation, minimum length doesn't consider as a
    // required combination but a compulsory requirement
    hasMinLength: value.length >= minLength,
    // Check if password contains upper-case
    hasLowerCase: (0, _passwordRegex.containLowerCase)(value),
    // Check if password contains any lower-case
    hasUpperCase: (0, _passwordRegex.containUpperCase)(value),
    // Check if password contains any number
    hasNumber: (0, _passwordRegex.containNumber)(value),
    // Check if password contains any symbols
    hasSymbol: (0, _passwordRegex.containSymbol)(value),
    // has more than or equal to the required password combination.
    hasMinCombination: validCombination["true"] >= minCombination
  };
}